export default "__VITE_ASSET__BKIfn0Zk__"